import React, { useEffect, useRef, useState } from 'react';
import { Box, Stack, TableRow, Typography } from '@mui/material';
import MyTableCell from '../../../../components/material-ui/adaptive/MyTableCell';
import CusLabelSelect from '../../../../components/material-ui/CusLabelSelect';
import { IconCopy } from '@tabler/icons-react';
import useColor from '../../../../hooks/site/useColor';
import CusInput from '../../../../components/material-ui/CusInput';
import BtnSave from '../../../../components/bonus/ui/BtnSave';
import BtnTrash from '../../../../components/bonus/ui/BtnTrash';
import useToast from '../../../../hooks/useToast';
import useBootstrapSize from '../../../../hooks/useBootstrapSize';
import ShowContainer from '../../../../components/material-ui/ShowContainer';
import { useTranslation } from 'react-i18next';

export default function CurrentReferral({
  refLinksInfo,
  link,
  selectRow,
  setSelectRow,
  deleteReferralHandler,
  onCommentChange
}) {
  const { t } = useTranslation();
  const { info } = useColor();
  const { infoToast } = useToast();
  const { isDesktop } = useBootstrapSize();
  const commentRef = useRef(null);

  const domains = refLinksInfo?.domainList || [];
  const botName = refLinksInfo?.botName;
  const linkId = link.id;
  const isSelect = selectRow === link.id;

  const domainsOptions = domains?.map((el) => ({ value: el.name, label: el.name }));
  const pbParams = link.pbParams;
  const comment = link.comment;

  const [domain, setDomain] = useState(domains?.find((el) => el.default)?.name);
  const [tempComment, setTempComment] = useState();
  const [tempStatParam, setTempStatParam] = useState(pbParams);
  const [saveDisable, setSaveDisable] = useState(false);

  useEffect(() => {
    setDomain(domains?.find((el) => el.default)?.name);
  }, [domains.length]);

  useEffect(() => {
    setTempStatParam(pbParams);
  }, [pbParams]);

  useEffect(() => {
    setTempComment(comment);
  }, [comment]);

  const onCopyClick = (text) => {
    navigator.clipboard
      .writeText(text)
      .then(() => {
        infoToast('copied to your clipboard');
      })
      .catch((err) => {
        console.error('Ошибка копирования: ', err);
      });
  };

  const onDelete = (id) => {
    deleteReferralHandler(id);
  };

  const onSaveComment = async (e) => {
    e.stopPropagation();
    setSaveDisable(true);
    await onCommentChange(linkId, tempComment, tempStatParam);
    setSaveDisable(false);
  };

  const textLinkOrig = `?start=r_${link.refcode}`;
  let tgLink = 'https://t.me/' + botName + textLinkOrig;
  let siteLink = textLinkOrig;
  if (pbParams) {
    tgLink += '&' + pbParams;
    siteLink += '&' + pbParams;
  }
  if (link.anchor) siteLink += link.anchor;
  tgLink = tgLink.replaceAll('&', '__');

  let copySiteLink = 'https://' + domain + textLinkOrig;
  if (tempStatParam) copySiteLink += '&' + tempStatParam;
  if (link.anchor) copySiteLink += link.anchor;

  return (
    <TableRow
      key={link.id}
      bgcolor={isSelect && info.light}
      onClick={() => {
        setSelectRow((prev) => (prev === link.id ? undefined : link.id));
      }}
      sx={{ cursor: 'pointer' }}>
      <MyTableCell>
        <Stack display={'flex'} direction={'column'} gap={0.5}>
          <Stack display={'flex'} direction={'row'} justifyContent={'space-between'}>
            <Stack display={'flex'} direction={'column'} gap={0.5}>
              <ShowContainer condition={domain}>
                <Stack display={'flex'} flexDirection={'row'} alignItems={'center'}>
                  https://
                  <CusLabelSelect
                    options={domainsOptions}
                    value={domain}
                    onChange={(val) => {
                      setDomain(val);
                    }}
                  />
                  {/* {siteLink} */}
                  <Typography p={0} whiteSpace={'nowrap'}>
                    {textLinkOrig}
                  </Typography>
                  &
                  <CusInput
                    value={tempStatParam}
                    placeholder={'Static parameters'}
                    width={isDesktop ? 210 : undefined}
                    onChange={(e) => setTempStatParam(e.target.value)}
                    onClick={(e) => e.stopPropagation()}
                    inputSx={{ padding: '4px' }}
                  />
                  {link.anchor}
                  <Stack marginRight={'auto'} display={'flex'} flexDirection={'row'} gap={1} pl={1}>
                    <IconCopy size={16} onClick={() => onCopyClick(copySiteLink)} />
                  </Stack>
                </Stack>
              </ShowContainer>

              <ShowContainer condition={botName}>
                <Stack display={'flex'} direction={'row'} gap={1}>
                  {tgLink}
                  <Stack marginRight={'auto'} display={'flex'} flexDirection={'row'} gap={1} px={1}>
                    <IconCopy size={16} onClick={() => onCopyClick(tgLink)} />
                  </Stack>
                </Stack>
              </ShowContainer>
            </Stack>
            <Stack display={'flex'} gap={1} direction={'column'}>
              <BtnSave onClick={onSaveComment} disabled={saveDisable} />
              <BtnTrash onDelete={() => onDelete(linkId)} />
            </Stack>
          </Stack>

          <Stack display={'flex'} direction={'row'} gap={1}>
            <CusInput
              label={'Comment (not visible to the player)'}
              width={'100%'}
              ref={commentRef}
              value={tempComment}
              onChange={(e) => setTempComment(e.target.value)}
              onClick={(e) => e.stopPropagation()}
              rows={2}
            />
          </Stack>
        </Stack>
      </MyTableCell>

      {/* <MyTableCell>
        <Stack display={'flex'} gap={1} direction={'column'}>
          <BtnSave onClick={onSaveComment} disabled={saveDisable} />
          <BtnTrash onDelete={() => onDelete(linkId)} />
        </Stack>
      </MyTableCell> */}
    </TableRow>
  );
}
